/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-container[_ngcontent-%COMP%]{position:fixed;display:block;min-width:20%;margin-left:auto;margin-right:auto;top:74px;left:50%;transform:translateX(-50%);z-index:1000}.alert-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{outline:0}.alert[_ngcontent-%COMP%]{padding:1.2rem!important}"];
export { styles as styles };
